/**
 * Normalize API image shapes to react-image-gallery items.
 * @param {Array<string|{url?: string}>} images
 */
export function mapGalleryItems(images) {
  if (!Array.isArray(images)) return [];

  return images
    .map((image) => {
      const url = typeof image === "string" ? image : image?.url;
      if (!url) return null;

      return {
        original: url,
        thumbnail: url,
        loading: "lazy",
      };
    })
    .filter(Boolean);
}
